import { render } from "./AsetDetailModal.vue?vue&type=template&id=d04e8820"
import script from "./AsetDetailModal.vue?vue&type=script&lang=js"
export * from "./AsetDetailModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__